import { InviteEmailConflict } from './invite-email-conflict.enum'
import type { InviteConflictMessages } from './mapInviteConflictErrorToMessage'

export const getInviteConflictValidationMessage = (
  conflict: InviteEmailConflict | null,
  messages: InviteConflictMessages
): string | null => {
  if (!conflict) {
    return null
  }

  return conflict === InviteEmailConflict.ALREADY_MEMBER ? messages.alreadyMember : messages.alreadyInvited
}
